<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetSourceList' }">预算源组</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy(list.is_default)">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="submit">提交</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="名称：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="金额：">
                                    <el-input v-model="list.total_amount" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="版本时间：">
                                    <el-input v-model="list.time" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="方向：">
                                    <div class="read_only">{{ list.direction_label }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="范围：">
                                    <el-input v-model="list.scope_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="备注：">
                                    <el-input v-model="list.remark" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="提交人：" v-if="isDefault != 1">
                                    <el-input
                                        v-model="list.submission_operator_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="审批人：" v-if="isDefault != 1">
                                    <el-input
                                        v-model="list.decision_operator_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"><el-form-item> &nbsp;</el-form-item> </el-col>
                            <el-col :span="12"
                                ><el-form-item label="审批状态：" v-if="isDefault != 1">
                                    <el-input
                                        v-model="list.approval_status_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }} </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="预算源列表" name="2">
                    <vBudgetSourceComponent v-if="flag" :postList="postList"></vBudgetSourceComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vBudgetSourceComponent from '../../listComponent/budget/budgetSourceComponent.vue';
export default {
    inject: ['reload'],
    name: 'budgetSourceDetail',
    components: {
        vBudgetSourceComponent
    },
    data() {
        return {
            list: {},
            activeNames: ['1', , '2'],
            rid: '',
            headerTitle: '预算源组详情',
            flag: false,
            isDefault: '',
            postList: {
                headerTitle: false,
                budget_item_rid: true,
                effectiveness: true,
                time_value: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downBtn: true,
                setBtn: true,
                params: {
                    budget_item_source_group_rid: '',
                    time: '',
                    can_operator: '',
                    approval_status: '',
                    isDefault: ''
                }
            }
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;

            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
    },
    methods: {
        // 提交
        submit() {
            this.$confirm('您确定要提交吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['budgetItemSourceGroupSubmit']({ rid: this.rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        //删除当前行  预算源组详情1
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetItemSourceGroupDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/budgetSourceList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'budgetSourceEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'budgetSourceEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy(is_default) {
            if (is_default == 1) {
                this.$message.warning('预设预算源组不允许复制！');
            } else {
                this.$router.push({
                    path: '/budgetSourceEdit',
                    query: {
                        type: 5,
                        id: this.rid
                    }
                });
            }
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetSourceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetItemSourceGroupDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.name;
                        this.postList.params.approval_status = res.data.approval_status;
                        this.postList.params.can_operator = res.data.can_operator;
                        this.postList.params.isDefault = res.data.is_default;
                        this.postList.params.budget_item_source_group_rid = res.data.rid;
                        this.postList.params.time = res.data.time;
                        this.flag = false;
                        this.$nextTick(() => {
                            this.flag = true;
                        });
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="less" scoped>
</style>
